import type { FC } from 'react'
import type { PlatformName } from '@/types'

interface PlatformIconProps {
    name: PlatformName
    className?: string
}

/**
 * Line-style platform marks drawn to sit next to lucide icons.
 */
export const PlatformIcon: FC<PlatformIconProps> = ({ name, className }) => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            focusable='false'
            className={className}
        >
            {name === 'instagram' && (
                <>
                    <rect x='3' y='3' width='18' height='18' rx='5.5' />
                    <circle cx='12' cy='12' r='4' />
                    <circle cx='17.4' cy='6.6' r='0.9' fill='currentColor' stroke='none' />
                </>
            )}

            {name === 'tiktok' && (
                <>
                    <path d='M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5' />
                    <path d='M14 3c.4 2.7 2.4 4.7 5 5' />
                </>
            )}

            {name === 'youtube' && (
                <>
                    <rect x='2.5' y='5.5' width='19' height='13' rx='4' />
                    <path d='M10.2 9.3v5.4l4.6-2.7z' fill='currentColor' />
                </>
            )}

            {name === 'linkedin' && (
                <>
                    <rect x='3' y='3' width='18' height='18' rx='3.5' />
                    <path d='M8 10.5V16.5' />
                    <circle cx='8' cy='7.6' r='0.95' fill='currentColor' stroke='none' />
                    <path d='M12 16.5v-6' />
                    <path d='M12 13.4a2.6 2.6 0 0 1 5.2 0v3.1' />
                </>
            )}

            {name === 'pinterest' && (
                <>
                    <circle cx='12' cy='12' r='9.5' />
                    <path d='M9.4 20.6l2.3-9.4' />
                    <path d='M9.9 15.2c.6.6 1.4.9 2.4.9 2.6 0 4.4-2.2 4.4-4.9 0-2.6-2-4.6-4.8-4.6-3 0-5 2.1-5 4.6 0 .9.3 1.7.8 2.2' />
                </>
            )}

            {name === 'x' && (
                <>
                    <path d='M4 4h4.6L20 20h-4.6z' />
                    <path d='M20 4l-6.6 7.4' />
                    <path d='M10.6 12.6L4 20' />
                </>
            )}
        </svg>
    )
}
